export default "__VITE_ASSET__Bn29z8lW__"